import React from 'react';
import { Alert } from '@material-ui/lab';

export const BaseAlert: React.FC = ({ children }) => (
  <Alert variant="outlined" severity="error">
    {children || 'Oops! an error occurred'}
  </Alert>
);
